import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	font-weight: 600;
	min-height: 128px;
	height: max-content;

	overflow: auto;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	width: 100%;
`;

export const IconContainer = styled.div`
	padding-top: 40px;
`;

export const Title = styled.div`
	padding: 20px 0;
	color: ${tokens.color_primary_lightest_title};

	text-align: center;
`;

export const CampaignContainer = styled.div`
	width: 100%;
	background-color: ${tokens.color_primary_lightest_select};

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 20px;
`;

export const CampaignImage = styled.img`
	padding-right: 10px;
`;

export const CampaignTitle = styled.div`
	color: ${tokens.color_primary_lightest_title};

	padding-bottom: 10px;
`;

export const CampaignText = styled.div`
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	color: ${tokens.color_primary_lightest_title};
`;

export const CenterText = styled.div`
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: ${tokens.color_primary_lightest_title};
	text-align: center;

	padding: 20px 40px 0 40px;
`;

export const ButtonContainer = styled.div`
	padding: 20px;
`;
